import { render, staticRenderFns } from "./AdminPayersPrefixesUpload.vue?vue&type=template&id=4a857893"
import script from "./AdminPayersPrefixesUpload.vue?vue&type=script&lang=js"
export * from "./AdminPayersPrefixesUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports